import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import {
    NotifyContainer,
} from './styles'
import NotificationService from 'services/Notification'
import { ICreateNewNotificationResponse, ICreateNotification } from 'types/notification'
import NotifyEventForm from './components/form/NotifyEventForm'
import { notifyEventSchema, NotifyEventType } from 'validator/notify_event_validator'
import { yupResolver } from '@hookform/resolvers/yup';
import NotificationSentSuccess from './components/notification_sent/NotificationSentSuccess'
import { useNavigate } from 'react-router-dom'
import { ROUTES_NAMES } from 'constants/name.routes'
import ComponentLoader from 'components/ComponentLoader'

const NotifyEvent = () => {
    const navigate = useNavigate()
    const [responseData, setResponseData] = useState<ICreateNewNotificationResponse|null>()

    const {
        register,
        handleSubmit,
        trigger,
        formState: { errors, isDirty },
        control,
        setValue,
        watch,
        getValues,
        resetField,
        reset
    } = useForm<NotifyEventType>({
        resolver: yupResolver(notifyEventSchema)
    })
    const makeNewNotificationFromZero = () => {
        setResponseData(null)
        reset()
        navigate(ROUTES_NAMES.notifyEvent, { replace: true })
    }

    if (responseData) {
        
        return (
        <NotifyContainer>
            <NotificationSentSuccess
                reset={reset}
                responseData={responseData}
                setResponseData={setResponseData}
                makeNewNotificationFromZero={makeNewNotificationFromZero}
            />
        </NotifyContainer>)
    }
    return (
        <NotifyContainer>
            <NotifyEventForm
                setResponseData={setResponseData}
                trigger={trigger}
                watch={watch}
                isDirty={isDirty}
                getValues={getValues}
                handleSubmit={handleSubmit}
                register={register}
                control={control}
                errors={errors}
                setValue={setValue}
            />
        </NotifyContainer>
    )
}


export { NotifyEvent }
